import { render, staticRenderFns } from "./menuConsumptionTable.vue?vue&type=template&id=6a2dc148&"
import script from "./menuConsumptionTable.vue?vue&type=script&lang=js&"
export * from "./menuConsumptionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports